module.exports = __webpack_public_path__ + "img/file-plus-01.31da9b45.svg";